module.exports = __webpack_public_path__ + "img/snowman.05dbeb06.svg";